import { NavBar, Button, Toast, Image, Grid, Dialog, NoticeBar, Selector, Popup, SearchBar } from 'antd-mobile'
import React, { useCallback, useEffect, useState, useMemo } from 'react'
import "./index.css"
import { useAuth } from '../../app/providers/AuthProvider';
import { teamApi } from '../../features/team/api/teamApi';

export default function TeamMember() {

    const teamInfo = JSON.parse(localStorage.getItem("teamId"))

    const [memberList, setMemberList] = useState([])
    const [totalMemberList, setTotalMemberList] = useState([])
    const [isAddPopupShow, setIsAddPopupShow] = useState(false)
    const [addSearchKey, setAddSearchKey] = useState('')

    const { memberInfo } = useAuth()

    const getMemberList = useCallback(() => {
        teamApi.getAvailableMembers(teamInfo?.yearId)
            .then(function (response) {
                setTotalMemberList(response.data.data)
            })
            .catch(function (error) {
                console.error('获取成员列表失败', error);
            })
    }, [teamInfo?.yearId])

    const getUserList = useCallback(() => {
        Toast.show({
            icon: 'loading',
        })
        teamApi.getDetail(teamInfo?.id)
            .then(function (response) {
                setMemberList(response.data.data)
                getMemberList()
            })
            .catch(function (error) {
                console.error('获取成员列表失败', error);
            })
            .finally(() => {
                Toast.clear()
            });
    }, [getMemberList, teamInfo?.id])

    useEffect(() => {
        getUserList()
    }, [getUserList])

    const removeMember = (item) => {
        if (memberInfo.admin !== 1) return;
        Dialog.confirm({
            title: "移除队员",
            content: `确定要从队伍中移除队员 [${item.memberName}] 吗？`,
            onConfirm: () => {
                const param = new FormData();
                param.append('teamId', teamInfo?.id);
                param.append("id", item.memberId)
                teamApi.removeMember(param)
                    .then(res => {
                        if (res.data.code === 200) {
                            Toast.show({ icon: 'success', content: '移除成功' })
                            getUserList()
                        }
                    })
            }
        })
    }

    const deleteTeam = () => {
        Dialog.confirm({
            title: <span style={{ color: '#FF4D4F' }}>彻底删除队伍</span>,
            content: `确定要删除队伍 [${teamInfo.teamName}] 吗？此操作不可撤销。`,
            confirmText: '确定删除',
            onConfirm: () => {
                const formData = new FormData();
                formData.append('id', teamInfo.id);
                teamApi.delete(formData)
                    .then(function (response) {
                        if (response.data.code === 200) {
                            Toast.show({
                                content: '删除完毕!',
                                icon: 'success',
                                afterClose: () => window.history.back()
                            })
                        } else {
                            Toast.show({ content: response.data.msg, icon: 'fail' })
                        }
                    })
            }
        })
    }

    const handleAddMember = (arr) => {
        if (arr.length > 0) {
            const param = new FormData();
            param.append('teamId', teamInfo?.id);
            param.append("id", arr[0])
            teamApi.addMember(param)
                .then(res => {
                    if (res.data.code === 200) {
                        Toast.show({ icon: 'success', content: '添加成功' })
                        getUserList()
                        setIsAddPopupShow(false)
                    }
                })
        }
    }

    const filteredTotalMembers = useMemo(() => {
        // Exclude current team members
        const currentIds = memberList.map(m => m.memberId);
        let list = totalMemberList.filter(m => !currentIds.includes(m.id));
        if (addSearchKey) {
            list = list.filter(m => m.name.toLowerCase().includes(addSearchKey.toLowerCase()));
        }
        return list;
    }, [totalMemberList, memberList, addSearchKey]);

    const captain = memberList?.find(item => item.memberId === teamInfo.teamCaptain);

    return (
        <div className="team-detail-container has-unified-nav">
            <NavBar
                className="unified-navbar fixed"
                onBack={() => window.history.back()}
            >
                队伍详情
            </NavBar>

            <div className="team-profile-header">
                <Image
                    src={teamInfo?.teamLogo}
                    className="team-detail-logo"
                    fit='cover'
                />
                <div className="team-detail-name">{teamInfo?.teamName}</div>
                <div className="team-detail-type-badge">
                    {teamInfo?.teamType === 0 ? '科朋队伍' : '外战队伍'}
                </div>
            </div>

            {memberInfo.admin === 1 && (
                <NoticeBar 
                    className="notice-bar-custom"
                    content='管理员权限：您可以点击头像右上角图标删除队员' 
                    color='default' 
                    closeable 
                />
            )}

            {teamInfo?.teamType === 0 && captain && (
                <div className="team-section">
                    <div className="team-section-title">领军人物</div>
                    <div className="captain-card">
                        <Image
                            src={captain.memberImage + "?x-oss-process=image/resize,m_fill,w_100,h_100,limit_0/auto-orient,1/quality,q_90"}
                            className="captain-avatar"
                        />
                        <div className="captain-info-text">
                            <div className="captain-name">{captain.memberName}</div>
                            <div className="captain-role-label">本队队长 Team Captain</div>
                        </div>
                    </div>
                </div>
            )}

            {teamInfo?.teamType === 0 && (
                <div className="team-section">
                    <div className="team-section-title">旗下队员</div>
                    <div className="member-list-card">
                        <Grid className="team-roster-grid" columns={4}>
                            {memberList?.filter(item => item.memberId !== teamInfo.teamCaptain).map(item => (
                                <Grid.Item key={item.memberId} className="team-roster-item">
                                    <div className="team-roster-avatar-frame">
                                        {/* 使用固定正方形图片并裁切，避免不同原图比例把头像拉成长椭圆。 */}
                                        <img
                                            src={item.memberImage + "?x-oss-process=image/resize,m_fill,w_100,h_100,limit_0/auto-orient,1/quality,q_90"}
                                            className="team-roster-avatar"
                                            alt={`${item.memberName}头像`}
                                        />
                                    </div>
                                    <div className="team-roster-name" title={item.memberName}>{item.memberName}</div>
                                    {memberInfo.admin === 1 && (
                                        <button type="button" className="team-roster-remove" onClick={() => removeMember(item)}>
                                            移除
                                        </button>
                                    )}
                                </Grid.Item>
                            ))}
                            {memberInfo.admin === 1 && (
                                <Grid.Item className="team-roster-add-item" onClick={() => {
                                    setAddSearchKey('')
                                    setIsAddPopupShow(true)
                                }}>
                                    <div className="team-roster-add-circle">+</div>
                                    <div className="team-roster-name">添加队员</div>
                                </Grid.Item>
                            )}
                        </Grid>
                    </div>
                </div>
            )}

            {memberInfo.admin === 1 && (
                <div className="delete-team-btn-box">
                    <div className="delete-team-warning-text">⚠️ 危险操作：解散后数据不可恢复</div>
                    <Button 
                        fill='outline'
                        className="delete-team-btn" 
                        block 
                        onClick={deleteTeam}
                    >
                        解散该支队伍
                    </Button>
                </div>
            )}

            <Popup
                visible={isAddPopupShow}
                onMaskClick={() => setIsAddPopupShow(false)}
                bodyClassName="captain-selection-popup"
                bodyStyle={{ maxHeight: '85vh', minHeight: '60vh', display: 'flex', flexDirection: 'column' }}
            >
                <div className="captain-popup-header">
                    <div className="captain-popup-title">添加新队员</div>
                    <SearchBar 
                        placeholder='输入姓名搜索' 
                        style={{ '--background': '#f2f3f5', '--border-radius': '10px' }}
                        onChange={val => setAddSearchKey(val)}
                    />
                </div>
                
                <div className="captain-popup-body">
                    <span className="create-team-sub-label" style={{ marginTop: 0 }}>科朋队员</span>
                    {filteredTotalMembers.filter(item => item.tempMember === null).length > 0 ? (
                        <Selector
                            className="premium-selector"
                            columns={3}
                            options={filteredTotalMembers.filter(item => item.tempMember === null).map(item => ({ label: item.name, value: item.id }))}
                            onChange={(arr) => handleAddMember(arr)}
                        />
                    ) : <div style={{ color: '#86909c', fontSize: '13px', padding: '10px' }}>暂无符合条件的成员</div>}

                    <span className="create-team-sub-label" style={{ marginTop: '20px' }}>临时队员</span>
                    {filteredTotalMembers.filter(item => [1, 2].includes(item.tempMember)).length > 0 ? (
                        <Selector
                            className="premium-selector"
                            columns={3}
                            options={filteredTotalMembers.filter(item => [1, 2].includes(item.tempMember)).map(item => ({ label: item.name, value: item.id }))}
                            onChange={(arr) => handleAddMember(arr)}
                        />
                    ) : <div style={{ color: '#86909c', fontSize: '13px', padding: '10px' }}>暂无符合条件的成员</div>}
                </div>
            </Popup>
        </div>
    )
}

